import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CustomerLayout from "../Customer/comman/master";
import { LoginINdex } from "../Auth/LoginINdex";
import GetStart from "../Customer/pages/GetStart";
import { Login } from "../Auth";
import CustomerHeader from "../Customer/pages/CustomerHeader";
import Footer from "../Customer/pages/Footer";
import ServiceDetailPage from "../Customer/pages/ServiceDetailPage";
import Contact from "../Customer/pages/Contact";
import About from "../Customer/pages/About";
import MyBookings from "../Customer/pages/MyBookings";
import Events from "../Customer/pages/Events";
import PaymentDetailsPage from "../Customer/pages/PaymentDetailsPage";
import MainEventPage from "../Customer/pages/MainEventPage";
import ForgotPassword from "../Auth/Forgotpassword";
import ResetPassword from "../Auth/Resetpassword";
import DemoServices from "../Customer/pages/DemoServices";
import DemoDetails from "../Customer/pages/DemoDetails";
import ProtectedRoute from "./ProtectedRoute";

function CustomerRoutes() {
  return (
    <>
      <BrowserRouter>
        <CustomerHeader />
        <Routes>
          <Route path="/" element={<CustomerLayout />}></Route>
          <Route path="/admin" element={<Login />} />
          <Route path="/cx_Login" element={<LoginINdex />} />
          <Route path="/Get_Start" element={<GetStart />} />
          <Route
            path="/service_details/:id/:locationName"
            element={<ServiceDetailPage />}
          />
          <Route path="/contact_us" element={<Contact />} />
          <Route path="/About_us" element={<About />} />
          <Route path="/My_Bookings" element={<MyBookings />} />
          <Route path="/Events" element={<MainEventPage />} />
          <Route path="/Events_details/:id" element={<Events />} />
          <Route path="/demo-services" element={<DemoServices />} />
          <Route path="/demo_details/:id/:locationName" element={
              <DemoDetails />
          } />

          <Route path="/payment-details/:id" element={<PaymentDetailsPage />} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Routes>
        {/* <Footer/> */}
      </BrowserRouter>
    </>
  );
}
export default CustomerRoutes;
